<template>
  <table class="r-table">

    <!-- 功能 -->
    <tr v-if="action || requester" class="action">
      <td :colspan="colCount" class="caption" style="text-align:right;">
        <template v-if="action">
          <v-btn v-if="action.indexOf(1)!=-1" color="primary" text x-small @click="onAdd">新增</v-btn>
          <v-btn v-if="hasDelete" color="primary" text x-small @click="onDelete" :disabled="!selectedRows.length">删除</v-btn>
          <v-btn v-if="saver" color="primary" text x-small @click="onSave" :disabled="!dataChanged">保存</v-btn>
        </template>
        <v-btn v-if="requester" color="primary" text x-small @click="onReload">刷新</v-btn>
      </td>
    </tr>

    <!-- 标题行 -->
    <tr>
      <th v-if="selectType>0" align="center" width="26">
        <div style="width:26px;">
          <mini-check-editor @click="onRowCheckAll($event)" v-if="selectType==2" @change="onCheckAll" :value.sync="checkAll"></mini-check-editor>
        </div>
      </th>
      <th v-if="showNo!=false" align="center" width="24" style="padding:0;" class="caption">
        <div style="width:24px;">#</div>
      </th>
      <th v-for="(h,i) in visibleHeader" :key="`h_${i}`" align="center">
        <div :style="`width:${h.width||(i==visibleHeader.length-1?null:100)}px;`">{{h.name}}</div>
      </th>
      <th v-if="hasDelete" width="40">
        <div style="width:40px;"></div>
      </th>
    </tr>

    <!-- 数据 -->
    <tr v-for="(r,i) in rows" :key="`r_${i}`" :class="{'row-state-add':r._state==1,'row-state-edit':r._state==2}">
      <td v-if="selectType>0" align="center" style="padding:0;">
        <mini-check-editor @click="onRowCheck($event,r,i)" @change="onCheckItem($event,i)" :value.sync="selectedRows.indexOf(i)!=-1"></mini-check-editor>
      </td>
      <td v-if="showNo!=false" class="caption" align="center" style="padding:0;" v-text="i+1"></td>
      <td v-for="(h,m) in visibleHeader" :key="`c_${i}_${m}`" :align="h.align||h.edit?'center':''" class="data-cell">
        <template v-if="h.edit">
          <!-- 单元格编辑器，仅支持Mini*Editor -->
          <mini-int-editor v-if="h.type==2" v-model="r[h.code]" @change="onCellValueChanged($event,i)" class="editor"></mini-int-editor>
          <mini-decimal-editor v-else-if="h.type==3" v-model="r[h.code]" @change="onCellValueChanged($event,i)" class="editor"></mini-decimal-editor>
          <mini-check-editor v-else-if="h.type==7" v-model="r[h.code]" @change="onCellValueChanged($event,i)" class="editor"></mini-check-editor>
          <mini-select-editor v-else-if="h.type==8 || h.type==14" v-model="r[h.code]" @change="onCellValueChanged($event,i)" class="editor" :items="h.coder"></mini-select-editor>
          <mini-text-editor v-else v-model="r[h.code]" @change="onCellValueChanged($event,i)" class="editor" :regex="h.regex"></mini-text-editor>
        </template>
        <template v-else>
          <!-- TODO 数据转换显示 -->
          <span v-if="h.render" v-html="h.render(h.code,r)"></span>
          <span v-else class="pl-1">{{r[h.code]}}</span>
        </template>
      </td>
      <td v-if="hasDelete">
        <a title="删除" @click="onRowDelete(i)">
          <v-icon color="primary" x-small>mdi-close</v-icon>
        </a>
      </td>
    </tr>

    <!-- 分页 -->
    <tr v-if="pagination" class="pagination">
      <td :colspan="colCount" align="right">
        <mini-select-editor width="50" style="height:20px;margin-top:3px;" v-model="page.size" required :items="pageSize" @change="onPageSize"></mini-select-editor>
        <v-btn icon x-small @click="onPageIndex(1)" :disabled="page.index==1">
          <v-icon color="primary" small>mdi-page-first</v-icon>
        </v-btn>

        <v-btn icon x-small @click="onPageIndex(page.index-1)" :disabled="page.index==1">
          <v-icon color="primary" small>mdi-chevron-left</v-icon>
        </v-btn>

        <mini-int-editor width="34" style="height:19px;text-align: center;" :value.sync="page.index" @change="onPageIndex" :disabled="page.num==1"></mini-int-editor>
        <span class="caption"> / {{page.num}}</span>

        <v-btn icon x-small @click="onPageIndex(page.index+1)" :disabled="page.index==page.num">
          <v-icon color="primary" small>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn icon x-small @click="onPageIndex(page.num)" :disabled="page.index==page.num">
          <v-icon color="primary" small>mdi-page-last</v-icon>
        </v-btn>
        <code class="pl-0 pr-0">{{page.total}}</code>
      </td>
    </tr>
  </table>
</template>
<script>
/**
 * action: 功能, 为false，则表示只读,值的格式为[1,2,3]
 *    1:insert, 2:update, 3:delete
 * header: 表头
 *    code: 
 *    name:
 *    render: 列渲染器
 *    type: 类型,根据类型可做自动渲染处理以及编辑组件渲染
 *    coder: 下拉项
 *    edit: 能否编辑
 *    regex: 输入时校验正则表达式
 *    width: 宽度,如果内容超长则自动使用省略号，鼠标移动到上面显示全部
 *    sort: 能否排序，默认不能排序(暂时不实现)
 *    align: 内容对齐方式，默认左对齐
 *    visible: 是否显示
 *    dftValue: 默认值(非只读模式有效)
 *    render: 单元格渲染函数
 * pagination: 排序信息，为false则表示不分页,默认为false
 * requester: 数据请求,只允许post请求
 *    auto: 是否自动加载数据,默认为true
 *    url: 
 *    param: 请求参数,如果是函数，则调用函数返回
 * saver: 数据存储,只允许post请求
 *    url:
 *    param: 请求参数,如果是函数，则调用函数返回
 * items: 如果参数items有值，则默认显示items的数据列表
 * showNo: 是否显示序号列(默认显示)
 * selectMode: 选择模式（0:不显示选择列,1：单选,2：多选), 如果此属性未设置，并且有删除操作，则选择默认自动切换到2
 * 组件描述：
 *    如果action中设置了3（删除），则会出现第一列的checkbox以及最后一列的删除操作
 *    
 * 
 * 问题遗留：
 *    如果列太多，需要有冻结列或者横向滚动
 * 
 */
export default {
  name: 'table-editor',
  props: [
    'value',
    'action', 'header', 'pagination', 'requester', 'saver', 'items', 'showNo', 'selectMode',
    // functions
    'rowCheck', 'rowCheckAll'
  ],
  data () {
    return {
      dw: 100, // 默认列宽
      rows: [],
      selectedRows: [],
      deleteRows: [],
      page: { size: this.pagination && this.pagination.size || 10, index: 1, total: 0, num: 0 },
      pageSize: [{ code: 10, name: 10 }, { code: 50, name: 50 }, { code: 100, name: 100 }],
    }
  },
  created () {
    this.rows = this.items || [];
    this.selectedRows = this.value || [];
  },
  mounted () {
    if (this.requester && this.requester.auto && this.requester.url) { // 数据请求
      this.requestData();
    }
  },
  computed: {
    hasDelete () { return this.action && this.action.indexOf(3) != -1 },
    hasEditor () { return !!this.header.find(h => h.edit) },
    selectType () { return (this.selectMode == null || this.selectMode == undefined || this.selectMode == '') ? (this.hasDelete ? 2 : 0) : this.selectMode },
    colCount () {
      return (this.showNo != false ? 1 : 0) +
        (this.selectType > 0 ? 1 : 0) + (this.header ? this.header.length : 0) + (this.hasDelete ? 1 : 0)
    },
    dataChanged () { return this.deleteRows.length || this.rows.filter(r => !!r._state).length },
    checkAll () { return this.rows.length == this.selectedRows.length && this.selectedRows.length },
    visibleHeader () { return (this.header && this.header.length) ? this.header.filter(h => h.visible !== false) : [] },
    defaultRowData () {
      let ret = {};
      this.header.forEach(h => {
        let v = h.dftValue;
        if (v != null && v != undefined && v != '') ret[h.code] = v;
      })
      return ret;
    }
  },
  watch: {
    items (v) { this.rows = v || [] },
    value (v) { this.selectedRows = v || [] }
  },
  methods: {
    requestData () {
      if (!this.requester) return;
      let dto = {}; // 查询参数： {pagination:{}, ...param},参考: com.rino.core.dto.dispatch.QueryParam
      if (this.pagination) dto.pagination = this.page;
      let rp = this.requester.param;
      if (rp) {
        if (typeof rp == 'function') {
          let rpv = rp(this);
          this.Utility.deepMerge(dto, rpv);
        } else {
          this.Utility.deepMerge(dto, rp);
        }
      }
      this.$post(this.requester.url, dto).then(res => {
        this.rows = res.data || [];
        if (this.pagination && res.pagination) {
          this.page = res.pagination;
        }
      })
    },

    // =================== action of reload
    onReload () {
      this.deleteRows = [];
      this.selectedRows = [];
      this.requestData();
    },

    // =================== action of add
    // onAddBefore(){},
    // onAddDefaultValueHandler(){},
    // onAddFormDataHandler(){},
    onAdd () { // 新增，默认在下方新增一行
      let formData = { _state: 1, ...this.defaultRowData };
      this.rows.push(formData);
    },

    // =================== action of row delete
    onRowDelete (index) {
      let row = this.rows[index];
      this.rows.splice(index, 1);
      if (row._state != 1) this.deleteRows.push({ _state: 3, ...row });
      let sIndex = this.selectedRows.indexOf(index);
      if (sIndex != -1) this.selectedRows.splice(sIndex, 1);
      let newSRows = [];
      this.selectedRows.forEach(sri => newSRows.push(sri > index ? --sri : sri))
      this.selectedRows = newSRows;
    },
    // ==================  action of rows delete
    onDelete () { // 
      let srs = this.selectedRows.sort().reverse();
      srs.forEach(idx => {
        let row = this.rows[idx];
        this.rows.splice(idx, 1);
        if (row._state != 1) this.deleteRows.push({ _state: 3, ...row });
      });
      this.selectedRows = [];
    },
    // =================== action of save
    onSave () { // 存储参数： {rows:[], ...param},参考: com.rino.core.dto.dispatch.DataPersistentDTO
      if (!this.saver) return;
      let editRows = this.rows.filter(r => !!r._state);
      let rows = [...editRows, ...this.deleteRows];
      if (typeof this.saver == 'function') this.saver(rows);
      else {
        let dto = {};
        let rp = this.saver.param;
        if (rp) {
          if (typeof rp == 'function') {
            let rpv = rp(this);
            this.Utility.deepMerge(dto, rpv);
          } else this.Utility.deepMerge(dto, rp);
        }
        dto.rows = rows;
        this.$post(this.saver.url, dto).then(() => {
          this.onReload();
        })
      }
    },
    // =================== event of check
    onRowCheckAll (e) {
      if (this.rowCheckAll) this.rowCheckAll(e);
    },
    onCheckAll (e) {
      this.selectedRows = [];
      if (e) {
        for (let i = 0, l = this.rows.length; i < l; i++) this.selectedRows.push(i);
      }
      this.$emit('input', this.selectedRows);
    },
    onRowCheck (e, row, index) {
      if (this.rowCheck) this.rowCheck(e, row, index);
    },
    onCheckItem (e, index) {
      if (e) {
        if (this.selectType == 1) {
          this.selectedRows.splice(0, 1, index);
        } else if (this.selectType == 2) {
          this.selectedRows.push(index);
        }
      } else {
        let sIndex = this.selectedRows.indexOf(index);
        this.selectedRows.splice(sIndex, 1);
      }
      this.$emit('input', this.selectedRows);
    },

    // ==================== event of cell value change
    onCellValueChanged (e, r) {
      let row = this.rows[r];
      let state = row._state;
      if (state != 1) this.$set(row, '_state', 2);
    },

    // ==================== event of pagination
    onPageIndex (index) {
      if (this.page.index == index) return;
      if (index < 1) index = 1;
      else if (index > this.page.num) index = this.page.num;
      this.page.index = index;
      this.$nextTick(this.onReload);
    },
    onPageSize () {
      this.onReload();
    }

  }
}
</script>